/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Counter from '../../../components/Counter';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Select from '../../../components/Select';
import Modal, { ModalHeader } from '../../../components/Modal';
import DatePicker from '../../../components/DatePicker';
import { classnames } from '../../../utils/text';
import { forEach, get, isEmpty } from 'lodash';
import useForm from '../../../hooks/useForm';
import { getVacationsOthersList } from '../../../apis/vacation/vacation-other';
import { getVacationsList, modifyVacationsLeave, modifyVacationsOthersUpdates } from '../../../apis/vacation/vacations';
import systemAlert from '../../../utils/systemAlert';
import { viewLoading } from '../../../utils/loading';
import { getDay } from '../../../utils/date';

const Vacation = ({ open, setOpen, vacationData, submit }) => {
  const [activeTab, setActiveTab] = useState(0);
  // 회사가 사용하는 기타 휴가 목록 리스트
  const [otherVacationTypeList, setOtherVacationTypeList] = useState([]);
  // 직원이 본래 가지고 있던 기타 휴가 목록
  const [originalHasVactionList, setOriginalHasVacationList] = useState([]);
  const [hasVacationList, setHasVacationList] = useState([]);
  // 직원에게 추가할 기타 휴가 목록
  const [otherVacationList, setOtherVacationList] = useState([]);

  // 수정완료 버튼 활성화
  const [editDisabled, setEditDisabled] = useState(true);

  useEffect(() => {
    if (activeTab === 1) {
      // 회사에서 사용하는 기타 휴가 목록
      getVacationsOthersList()
        .then((res) => {
          const list = [];
          forEach(res.data.vacations, (vacation) => {
            if (vacation.isActive) {
              list.push({ label: vacation.title, value: vacation.idx });
            }
          });
          setOtherVacationTypeList(list);
        });

      // 직원이 가지고 있는 기타 휴가 조회
      getVacationsList({ search: { employeeIdxs: [vacationData.employeeIdx], vacationType: 'other' } })
        .then((res) => {
          // 사용 갯수가 남은 휴가만 확인
          res.data.vacations = res.data.vacations.filter((vacation) => vacation.usableCount > 0);
          setOriginalHasVacationList(res.data.vacations.map((v) => ({
            ...v,
            adjustmentCount: 0
          })));
          setHasVacationList(res.data.vacations.map((v) => ({
            ...v,
            adjustmentCount: 0
          })));
        });
    }

    setEditDisabled(true);

    setOtherVacationList([]);
  }, [activeTab, vacationData]);

  useEffect(() => {
    if (!open) {
      setActiveTab(0);
      setOtherVacationList([]);
      setHasVacationList([]);
    }
  }, [open]);

  const VACATION_TYPE = [
    { label: '연차', action: setActiveTab },
    { label: '기타휴가', action: setActiveTab },
  ];

  const cancel = () => {
    setOpen(false);
  };

  const _submit = (form) => {
    let body = {};
    switch (activeTab) {
      case 0:
        // 연차 부여
        body = {
          employeeIdxs: [vacationData.employeeIdx],
          description: form.description,
          addUsableCount: form.addUsableCount,
        };
        systemAlert(`${vacationData.employeeName}님에게 연차를 부여하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                viewLoading(true);
                modifyVacationsLeave(body).then(() => { submit(); setOpen(false); }).catch(() => { }).finally(() => viewLoading(false));
              }
            }
          ]
        }
        );
        break;
      case 1:
        // 기타 휴가 부여
        body = {
          targetEmployeeIdx: vacationData.employeeIdx,
          createList: otherVacationList.map((v) => ({
            ...v,
            expiredAt: v.expiredAt.toString(),
            createCount: v.adjustmentCount
          })),
          updateList: [],
          deleteList: []
        };
        forEach(hasVacationList, v => {
          if (v.adjustmentCount !== 0 || v.isChange === true) {
            body.updateList.push({
              vacationIdx: v.vacationIdx,
              startAt: v.startAt,
              expiredAt: v.expiredAt.toString(),
              addUsableCount: v.adjustmentCount || 0,
              description: v.description || "",
            });
          }
        });

        const deleteList = originalHasVactionList.filter(({ vacationIdx: id1 }) => !hasVacationList.some(({ vacationIdx: id2 }) => id1 === id2));
        forEach(deleteList, (value) => {
          body.deleteList.push(value.vacationIdx);
        });

        systemAlert(`${vacationData.employeeName}님의 기타휴가를 수정하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                viewLoading(true);
                modifyVacationsOthersUpdates(body)
                  .then(() => {
                    submit(); setOpen(false);
                  })
                  .finally(() => viewLoading(false));
              }
            }
          ]
        }
        );
        break;
      default:
        break;
    }
  };

  const {
    form,
    setForm,
    handleSubmit,
    handleOnChange,
  } = useForm({
    description: '',
    addUsableCount: 1,
  },
    _submit
  );

  const handleAddOtherVacation = () => {
    const vacation = {
      otherIdx: otherVacationTypeList[0].value,
      adjustmentCount: 1,
      startAt: getDay(),
      expiredAt: "",
      description: ""
    };

    // setOtherVacationList((oldVal) => [vacation, ...oldVal]);
    const newArray = [...otherVacationList];
    newArray.unshift(vacation);
    setOtherVacationList(newArray);
  };

  const handleRemoveHasOtherVacation = (idx) => {
    let newArray = [...hasVacationList];
    newArray = newArray.filter((vacation, vacationIndex) => vacationIndex !== idx);
    setHasVacationList(newArray);

    setEditDisabled(false);
  };

  const handleRemoveOtherVacation = (idx) => {
    let newArray = [...otherVacationList];
    newArray = newArray.filter((vacation, vacationIndex) => vacationIndex !== idx);
    setOtherVacationList(newArray);
  };

  const getDisabled = () => {
    let disabled = true;
    if (activeTab === 0) {
      if (form.addUsableCount !== 0) disabled = false;
    } else {
      if (hasVacationList.some((v) => v.adjustmentCount !== 0 || v.isChange === true)
        || otherVacationList.some((v) => v.adjustmentCount !== 0)
        || editDisabled === false
      ) {
        disabled = false;
      }
    }
    return disabled;
  };

  return (
    <Modal isOpen={open} close={cancel} type="fit">
      <div className="vacation-write">
        <ModalHeader className="vacation-modal-header">{`${vacationData.employeeName}님의 휴가`}</ModalHeader>
        <div className="header-button-wrap">
          {/* <Button label="취소" color="text" onClick={cancel} /> */}
          <Button label="수정완료"
            onClick={handleSubmit}
            disabled={getDisabled()}
          />
        </div>
        <ul className="tab-list">
          {VACATION_TYPE.map((tab, idx) => (
            <li
              key={idx}
              className={classnames("tab-item", {
                active: activeTab === idx,
              })}
            >
              <a onClick={() => tab.action(idx)}>{tab.label}</a>
            </li>
          ))}
        </ul>
        <div className="vacation-modal-body">
          {activeTab === 0 && (
            <div className="vacation-leave-container">
              <div className="vacation-leave-wrap">
                <p className="vacation-label">연차잔여일수</p>
                <div className="vacation-input-wrap">
                  <div className="usable-count-wrap">
                    {`${get(vacationData, 'validLeaveCreateCount')}일`}
                  </div>
                </div>
              </div>
              <div className="vacation-leave-wrap">
                <p className="vacation-label">연차조정일수</p>
                <div className="vacation-input-wrap">
                  <Counter
                    className="vacation-counter"
                    field={{
                      unit: "일",
                      handleChange: (data) => {
                        setForm({
                          ...form,
                          addUsableCount: data.counter
                        });
                      },
                    }}
                    data={0}
                    step={0.25}
                  />
                </div>
              </div>
              <div className="vacation-leave-wrap description">
                <p className="vacation-label">조정사유</p>
                <div className="vacation-input-wrap">
                  <Input placeholder="조정사유 입력" value={form.description} name="description" onChange={handleOnChange} />
                </div>
              </div>
            </div>
          )}
          {activeTab === 1 && (
            <>
              <Button size="sm" className="w-full mt-22 mb-22" disabled={isEmpty(otherVacationTypeList)} color="gray-line" label="추가" onClick={handleAddOtherVacation} />
              {isEmpty(hasVacationList) && isEmpty(otherVacationList) ? (<>{vacationData.employeeName}님에게 부여 된 기타 휴가가 없습니다.</>) : (
                <div className="vacation-other-container">
                  {/* 추가할 리스트 */}
                  {otherVacationList.map((vacation, idx) => {
                    return (
                      <div className="other-vacations-list-container" key={idx}>
                        <div className="other-vacation-title-wrap">
                          <p className="vacation-label">기타휴가 종류</p>
                          <p className="vacation-label expire-date">유효기간</p>
                          <p className="vacation-label">휴가일수</p>
                        </div>
                        <div className="other-vacation-list-wrap">
                          <div className="vacation-input-wrap">
                            <Select list={otherVacationTypeList} value={vacation.otherIdx} onChange={(e) => {
                              let newArray = [...otherVacationList];
                              newArray[idx] = {
                                ...newArray[idx],
                                otherIdx: e.target.value
                              };
                              setOtherVacationList(newArray);
                            }} />
                          </div>
                          <div className="vacation-input-wrap expire-date">
                            <DatePicker
                              defaultValue={vacation.expiredAt.toString()}
                              onChange={(date) => {
                                if (vacation.expiredAt.toString() === date.datepicker.toString()) return;
                                let newArray = [...otherVacationList];
                                newArray[idx] = {
                                  ...newArray[idx],
                                  expiredAt: date.datepicker.toString()
                                };
                                setOtherVacationList(newArray);
                              }}
                            />
                          </div>
                          <div className="vacation-input-wrap">
                            <Counter
                              className="vacation-counter"
                              field={{
                                unit: "일",
                                handleChange: (data) => {
                                  let newArray = [...otherVacationList];
                                  newArray[idx] = {
                                    ...newArray[idx],
                                    adjustmentCount: data.counter
                                  };
                                  setOtherVacationList(newArray);
                                },
                              }}
                              min={0.25}
                              data={0}
                              step={0.25}
                            />
                          </div>
                          <Button className="float-right delete-button" label="삭제하기" color="gray-line" onClick={() => handleRemoveOtherVacation(idx)} />
                        </div>
                        <div className="vacation-other-description-wrap">
                          <p className="vacation-label">조정사유 추가</p>
                          <div className="vacation-input-description-wrap">
                            <Input
                              placeholder="조정사유 입력"
                              name="description"
                              onChange={(e) => {
                                let newArray = [...otherVacationList];
                                newArray[idx] = {
                                  ...newArray[idx],
                                  description: e.target.value
                                };

                                setOtherVacationList(newArray);
                              }}
                              value={vacation.description}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* 현재 본인이 가지고 있는 리스트 */}
                  {hasVacationList.map((vacation, idx) => (
                    <div className="other-vacations-list-container" key={idx}>
                      <div className="other-vacation-title-wrap">
                        <p className="vacation-label">기타휴가 종류</p>
                        <p className="vacation-label expire-date">유효기간</p>
                        <p className="vacation-label">잔여일수</p>
                        <p className="vacation-label">조정일수</p>
                      </div>
                      <div className="other-vacation-list-wrap">
                        <div className="vacation-input-wrap">
                          <Select list={otherVacationTypeList} value={vacation.otherIdx} onChange={(e) => {
                            let newArray = [...hasVacationList];
                            newArray[idx] = {
                              ...newArray[idx],
                              otherIdx: e.target.value
                            };
                            setHasVacationList(newArray);
                          }} />
                        </div>
                        <div className="vacation-input-wrap expire-date">
                          <DatePicker
                            defaultValue={vacation.expiredAt.toString()}
                            onChange={(date) => {
                              if (vacation.expiredAt.toString() === date.datepicker.toString()) return;
                              let newArray = [...hasVacationList];
                              newArray[idx] = {
                                ...newArray[idx],
                                expiredAt: date.datepicker.toString(),
                                isChange: true
                              };

                              setHasVacationList(newArray);
                            }}
                          />
                        </div>
                        <div className="vacation-input-wrap">
                          <div className="usable-count-wrap">
                            {`${get(vacation, 'usableCount')}일`}
                          </div>
                        </div>
                        <div className="vacation-input-wrap">
                          <Counter
                            className="vacation-counter"
                            field={{
                              unit: "일",
                              handleChange: (data) => {
                                let newArray = [...hasVacationList];
                                newArray[idx] = {
                                  ...newArray[idx],
                                  adjustmentCount: data.counter
                                };
                                setHasVacationList(newArray);
                              },
                            }}
                            min={vacation.usableCount * -1}
                            data={0}
                            step={0.25}
                          />
                        </div>
                        <Button className="float-right delete-button" label="삭제하기" color="gray-line" onClick={() => handleRemoveHasOtherVacation(idx)} />
                      </div>
                      <div className="vacation-other-description-wrap">
                        <p className="vacation-label">조정사유 수정</p>
                        <div className="vacation-input-description-wrap">
                          <Input placeholder="조정사유 입력" name="description"
                            onChange={(e) => {
                              let newArray = [...hasVacationList];
                              newArray[idx] = {
                                ...newArray[idx],
                                description: e.target.value
                              };
                              setHasVacationList(newArray);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                </div>
              )}
            </>
          )}
        </div>
        <div className="vacation-modal-footer">
          <div className="button-wrap">
            <Button label="취소" color="text" onClick={cancel} />
            {/* <Button label="수정완료"
              onClick={handleSubmit}
              disabled={getDisabled()}
            /> */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Vacation;